fragment NutshellMarketingBannerInfo on NutshellMarketingStats {
    gate {
        error {
            reason
            message
        }
    }
    shouldShowImportUnsubscribesBanner
}
